<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="groupValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.name')"
                label-classes="form-control-label required"
                :placeholder="$t('common.name')"
                v-model="value.name"
                name="name"
                rules="required"
                :error="errors.get('name')">
            </base-input>

            <base-input class="mb-3"
                :label="$t('common.description')"
                name="description"
                :error="errors.get('description')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('common.description')"
                    v-model="value.description"
                ></textarea>
            </base-input>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="pt-2 mb-5">
                
                <el-table class="table-responsive table-flush"
                        :show-header="false"
                        :data="sortedLearners"
                        ref="members"
                        @select="learnerToggled">

                    <el-table-column type="selection"
                        align="left"
                        min-width="120px">
                    </el-table-column>

                    <el-table-column width="72" class-name="avatar-cell">
                        <template v-slot="{row}">

                            <a href="#" class="avatar rounded-circle" @click.prevent="toggleLearner(row)">
                                <img alt="Image placeholder" :src="row.avatar">
                            </a>

                        </template>
                    </el-table-column>

                    <el-table-column class-name="name-cell">
                        <template v-slot="{row}">

                            <h4 class="mb-0">
                                <a href="#" @click.prevent="toggleLearner(row)">
                                    {{ row.name }}
                                </a>
                            </h4>
                            <small v-if="row.owner">
                                {{ row.owner.name }}
                            </small>
                            <small v-if="row.entity">
                                / {{ row.entity.name }}
                            </small>

                        </template>
                    </el-table-column>
                    
                </el-table>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {
        
        props: ['value', 'errors', 'modal', 'learners'],

        created() {
            this.errors.setValidator('groupValidator', this)
        },

        watch: {

            value(group) {
                this.$refs.members.clearSelection();
                group.members_selection.forEach(memberId => {
                    let learner = this.learners.find(learner => learner.id == memberId)
                    this.$refs.members.toggleRowSelection(learner);
                });
            }
        },

        computed: {
            
            sortedLearners() {
                return [...this.learners].sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
            },
        },

        methods: {

            toggleLearner(learner) {
                if (this.value.members_selection.includes(learner.id)) {
                    this.value.members_selection = this.value.members_selection.filter(item => item !== learner.id)
                    this.$refs.members.toggleRowSelection(learner, false)
                } else {
                    this.value.members_selection.push(learner.id)
                    this.$refs.members.toggleRowSelection(learner, true)
                }
            },

            learnerToggled(selection, learner) {
                this.value.members_selection = selection.map(learner => learner.id)
            },

            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>

<style scoped>

    form >>> .avatar-cell {
        padding-right: 0;
    }
    form >>> .name-cell {
        padding-left: 1rem;
    }
    form >>> .el-table-column--selection .el-checkbox__inner {
        border: 1px solid #a5a8ad;
    }
</style>
